import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const WonderfulStart = lazyWithPreload(() => import('./WonderfulStart'))
